import { Client } from '@/utilities/api/Client';
import { QueryUtil } from '@/utilities/Query';

export class JobApi {
  static getIsProcessing (
    retailerId: string,
  ): Promise<boolean> {
    const queryString = QueryUtil.stringify({ retailerId });
    return Client(`job/is-processing?${queryString}`);
  }
}
